export const NOTES = 'https://notes-app-99.herokuapp.com/notes'
export const BIN = 'https://notes-app-99.herokuapp.com/bin'
export const LABELS = 'https://notes-app-99.herokuapp.com/labels'
